export const wifioptions = [
    {
        key: "1",
        text: "Sin encriptación",
        value: "Sin encriptación",
        name: "Sin encriptación"
    },
    {
        key: "2",
        text: "WEP",
        value: "WEP",
        name: "WEP"
    },
    {
        key: "3",
        text: "WPA/WPA2",
        value: "WPA/WPA2",
        name: "WPA/WPA2"
    },
]